import { useQuery } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Category } from '@/types/types';

export const useCategories = () => {
  const { axiosInstance } = useApi();
  return useQuery<Category[]>({
    queryKey: queryKeys.categories.all.queryKey,
    queryFn: async () => {
      const { data } = await axiosInstance.get<Category[]>('/api/v1/categories');
      return data;
    },
  });
};

export default useCategories;
